import Tabs from "@atlaskit/tabs";
import type {ComponentProps} from "react";

export function AnankeTabs(props: ComponentProps<typeof Tabs>) {
    return <Tabs {...props} />;
}
